export default "__VITE_ASSET__DiOLUWiu__"